/**
 * 계층 1(코어) 공용 타입. **DOM·hls.js·fetch 를 참조하지 않는다** (CLAUDE.md 절대 규칙 6).
 * 이 디렉터리는 `tsconfig.core.json` 으로 DOM lib 없이 컴파일되므로 위반이 타입 에러로 드러난다.
 */
export const RECEIVER_ERROR_CODES = [
    /** 플레이리스트가 빈 배열이다. `ready` 인 상품이 없을 때 정상적으로 발생한다. */
    'EMPTY_PLAYLIST',
    /** 플레이리스트 요청 실패 (네트워크·서버). */
    'PLAYLIST_FETCH_FAILED',
    /** 재생 시작 실패. 자동재생 정책 거부를 포함한다. */
    'PLAYBACK_FAILED',
    /** 꼬리 시점에 전환이 준비되지 않아 어댑터가 전환을 포기했다 (`onAbandoned`). */
    'TRANSITION_ABANDONED',
];
/**
 * 꼬리 프리롤 길이(초). M0 실측값(`spike/index.html` 의 `PREROLL_S`)을 그대로 유지한다.
 *
 * 줄여서 되찾을 수 있는 콘텐츠는 평균 15.6ms 뿐인데 줄이면 프리즈가 다시 나타날 위험이 있다.
 * 근거: `docs/spike-result.md` 「M5·M6 설계에 미치는 영향」 4.
 */
export const DEFAULT_PREROLL_SEC = 0.15;
/**
 * 인코딩 규격이 30fps 고정이므로(CLAUDE.md 절대 규칙 4) 프레임 간격은 상수다.
 * 마지막 프레임 판정과 T_freeze 산술이 모두 이 값을 기준으로 한다.
 */
export const FRAME_DURATION_SEC = 1 / 30;
//# sourceMappingURL=types.js.map